const Locations = (function () {

    const $ = require('jquery');
    const self = {};
    const Template = require('./../lib/template');
    //  Location Manager (https://github.com/KidkArolis/location-bar)
    const LocationBar = require('./../lib/location-bar');
    const $filter = $('[data-ajax-map-list-area]');
    const $locationMap = $('[data-google-map="location"]');
    const mapStyles = [
        {
            "stylers": [
                {
                    "saturation": -100
                },
                {
                    "gamma": 1
                }
            ]
        },
        {
            "elementType": "labels.text.stroke",
            "stylers": [
                {
                    "visibility": "off"
                }
            ]
        },
        {
            "featureType": "poi.business",
            "elementType": "labels.text",
            "stylers": [
                {
                    "visibility": "off"
                }
            ]
        },
        {
            "featureType": "poi.business",
            "elementType": "labels.icon",
            "stylers": [
                {
                    "visibility": "off"
                }
            ]
        },
        {
            "featureType": "poi.place_of_worship",
            "elementType": "labels.text",
            "stylers": [
                {
                    "visibility": "off"
                }
            ]
        },
        {
            "featureType": "poi.place_of_worship",
            "elementType": "labels.icon",
            "stylers": [
                {
                    "visibility": "off"
                }
            ]
        },
        {
            "featureType": "road",
            "elementType": "geometry",
            "stylers": [
                {
                    "visibility": "simplified"
                }
            ]
        },
        {
            "featureType": "water",
            "stylers": [
                {
                    "visibility": "on"
                },
                {
                    "saturation": 50
                },
                {
                    "gamma": 0
                },
                {
                    "hue": "#50a5d1"
                }
            ]
        },
        {
            "featureType": "administrative.neighborhood",
            "elementType": "labels.text.fill",
            "stylers": [
                {
                    "color": "#333333"
                }
            ]
        },
        {
            "featureType": "road.local",
            "elementType": "labels.text",
            "stylers": [
                {
                    "weight": 0.5
                },
                {
                    "color": "#333333"
                }
            ]
        },
        {
            "featureType": "transit.station",
            "elementType": "labels.icon",
            "stylers": [
                {
                    "gamma": 1
                },
                {
                    "saturation": 50
                }
            ]
        }
    ];
    const clusterStyles = [
        {
            textSize: 18,
            textColor: 'white',
            url: rk_globals.theme_path + '/dist/img/maps/cluster.svg',
            width: 32,
            height: 32
        }
    ];
    const locationBar = new LocationBar();

    self.init = function () {

        if ($filter.length > 0) {

            require('../lib/google-map');

            self.postType = $filter.data('post-type');

            self.ajaxOnPageLoad = ($filter.data('ajax-onload') === true);
            self.$resultHolder = $filter.find('[data-results-holder]');
            self.$paginationHolder = $filter.find('[data-pagination-holder]');

            let $filterForm = $filter.find('[data-filter-form]');
            let $filterFormFields = $filterForm.find('input[type="checkbox"], input[type="radio"], select');

            locationBar.start({
                pushState: true
            });

            //  Initial Map
            $locationMap.customGoogleMap({
                cluster: {
                    show: true,
                    styles: clusterStyles
                },
                infoWindow: {
                    show: true,
                    panOnClose: false
                },
                map: {
                    draggable: true,
                    styles: mapStyles
                },
                markers: {
                    data: []
                }
            });

            self.showInfoWindow();
            self.noResults();

            if ($('#map:visible').length) {
                self.updateMap();
            }

            //
            $('.tabs').on('change.zf.tabs', function () {
                self.renderOverview();
            });

            //  Ajax the changed URL
            locationBar.onChange(function (path) {
                self.renderOverview(path);
            });

            //  Handle all field of the form to process the filters (taxonomies)
            $filterFormFields.on('change', function () {
                $filterForm.submit();
            });

            //  Handle form submit
            $filterForm.on('submit', function (ev) {
                ev.preventDefault();

                let hash = window.location.hash;
                let pathname = window.location.pathname;
                //  Strip paginator from filter.
                //  When you're on page 2 and use the filter you need a new search, not a filtered page 2
                let url = pathname.replace(/page\/[0-9]\//g, '');

                //  Serialized form data
                let data = $(this).find(':input').filter(function (index, element) {
                    return $(element).val() != '';
                }).serialize();

                if (data) {
                    url += '?' + decodeURIComponent(data);
                }

                if (hash) {
                    url += hash;
                }

                //  Update URL
                locationBar.update(url, {trigger: true});
            });

            //  Handle paginator
            self.$paginationHolder.on('click', 'a', function (ev) {
                ev.preventDefault();

                let href = this.href;
                let url = href.replace(/^.*\/\/[^\/]+/, '');
                let suffix = '';
                let hash = window.location.hash;

                if (hash) {
                    suffix = hash;
                }

                //  Update URL
                locationBar.update(url + suffix, {trigger: true});
            });

        }

    };

    self.renderOverview = function (path) {

        if (path) {

            path = (!path.startsWith('/') ? '/' : '') + path;
        } else {

            path = window.location.href;
        }

        if ($('#map:visible').length) {

            self.updateMap(path);
        } else if ($('#list:visible').length) {

            self.updateList(path);
        }

    };

    /**
     * Renders the list view
     * @param path
     */
    self.updateList = function (path) {

        //  Scroll to the top of the results
        App.Globals.$scrollAnimators.animate({
            scrollTop: $filter.offset().top - $('#header').height()
        });

        App.Globals.$body.addClass('show-loader');

        $.ajax({
            url: path,
            data: {
                json: true
            },
            dataType: 'json'
        }).done(function (data) {

            Template.render(self.$resultHolder, rk_globals.theme_path + '/views/parts/' + self.postType + '/set.twig', data);
            Template.render(self.$paginationHolder, rk_globals.theme_path + '/views/parts/pagination.twig', data);

            App.Globals.$body.removeClass('show-loader');

        });

    };

    /**
     * Map the results of the Endpoint to uniformed Array the CustomGoogleMap plugin understands
     * @param data
     * @return {Array}
     */
    self.buildMarkers = function (data) {

        let markers = [];

        if (data.posts.length > 0) {

            for (let index = 0; index < data.posts.length; index++) {

                let marker = data.posts[index];
                let markerData = {
                    custom: {
                        id: marker.id
                    },
                    position: {
                        lat: parseFloat(marker.custom.location__google_maps.lat),
                        lng: parseFloat(marker.custom.location__google_maps.lng)
                    }
                };

                //  Add Custom Icon
                let defaultIcon = rk_globals.theme_path + '/dist/img/maps/marker.svg';

                //  TODO: fix ugly checks
                if (marker.terms.location__type) {
                    if (marker.terms.location__type[0].custom) {
                        if (marker.terms.location__type[0].custom.location__type_color) {
                            defaultIcon = rk_globals.theme_path + '/dist/img/maps/marker-' + marker.terms.location__type[0].custom.location__type_color + '.svg';
                        }
                    }
                }

                markerData.icon = {
                    default: {
                        url: defaultIcon,
                        size: {
                            height: 24,
                            width: 18
                        }
                    },
                    active: {
                        url: defaultIcon,
                        size: {
                            height: 24,
                            width: 18
                        }
                    }
                };

                markers.push(markerData);

            }

        }

        return markers;
    };

    /**
     * Filter Markers by URL change (From Filter.js)
     */
    self.updateMap = function (path) {

        App.Globals.$body.addClass('show-loader');
        $locationMap.removeClass('show-no-results-message');

        $.ajax({
            url: path,
            data: {
                no_paging: true,
                json: true
            },
            dataType: 'json'
        }).done(function (data) {

            if (data.posts.length > 0) {

                let markers = self.buildMarkers(data);

                $locationMap.customGoogleMap('filterMarkers', markers);
                App.Globals.$body.removeClass('show-loader');

            } else {

                //  Trigger no results event
                $locationMap.trigger('locations-no-results');

            }

        });

    };

    /**
     * Handle no-result event to show message on map
     */
    self.noResults = function() {

        $locationMap
            .on('locations-no-results', () => {

                $locationMap.customGoogleMap('setCenter');

                App.Globals.$body.removeClass('show-loader');

                //  Show no results box
                $locationMap.addClass('show-no-results-message');

            });
    };

    /**
     * Opens info window
     */
    self.showInfoWindow = function () {

        $locationMap.on('map:infowindow:open:id', function (ev, markerId) {

            //  API Call to retrieve Posts
            $.ajax({
                cache: false,
                data: {
                    no_paging: true,
                    json: true,
                    id: markerId
                },
                dataType: 'json',
                url: '/api/locations/'
            }).done(function (data) {

                let html = Template.renderInfoWindow(rk_globals.theme_path + '/views/ajax/infowindow.twig', data, markerId);

                if (html) {

                    $locationMap.customGoogleMap('showInfoWindow', markerId, html);

                }

            });

        });

    };

    return self;

}());

module.exports = Locations;
